import axios from "axios";

//axios.defaults.withCredentials = true
axios.defaults.baseURL =  "/api/student/";
axios.defaults.paramsSerializer = {
    indexes: null, // by default: false
};

export default axios;
